module.exports = __webpack_public_path__ + "static/img/LEXUS.beb7023.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos_vehicules/LEXUS.png
// module id = 4KtG
// module chunks = 1